export default "ed3a0d4dd1219a48.svg"